import {AfterViewInit, Component, inject} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {ProductsService} from "@services/products/products.service";

@Component({
  selector: 'app-products',
  imports: [
    RouterOutlet
  ],
  templateUrl: './products.component.html',
  standalone: true,
  styleUrl: './products.component.scss'
})
export class ProductsComponent implements AfterViewInit {

  private productsService = inject(ProductsService);

  ngAfterViewInit() {
    this.productsService.fetchProducts().subscribe((data: any) => {
      this.productsService.updateProductsList(data);
    });
  }

}
